import Query from '../Report';

export const getGoogleFeeds = new Query('domains-google-feeds');
